/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

var debounce = (function (fn, delay) {
  var timeout = null;

  var debounced = function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }

    timeout = setTimeout(function () {
      return fn.apply(void 0, args);
    }, delay);
  };

  return debounced;
});

export { debounce as default };
//# sourceMappingURL=debounce.js.map
